
import { StripeCheckout, Bus } from 'vue-stripe'
export default {

  components: {
    'stripe-checkout': StripeCheckout
  },

  methods: {

    PurchaseOnPurchaseAddKit: function (payload) {
      delete payload.defaults
      const user = this.PurchasePurchaser
      const stripeToken = payload.token
      const description = this.product.description
      const data = {...user, stripeToken, description}
      this.$store.dispatch('postOrder', data)
      console.log('add kit', data)
    },
    PurchaseOnPurchaseSendKit: function (payload) {
      delete payload.defaults
      const user = this.PurchasePurchaser
      const stripeToken = payload.token
      const description = this.product.description
      const data = {...user, stripeToken, description}
      this.$store.dispatch('postOrder', data)
      console.log('send kit', data)
    }
  },
  mounted: function () {
    // Trigger stripe success callbacks
    Bus.$on('vue-stripe.success', payload => {
      console.log('vue-stripe.success', payload)
      switch (payload.formId) {
        case 'SEND_KIT':
          console.log('SEND_KIT')
          this.PurchaseOnPurchaseSendKit(payload)
          break
        case 'ADD_KIT':
          console.log('ADD_KIT')
          this.PurchaseOnPurchaseAddKit(payload)
          break
      }
    })
  },

  computed: {
    PurchaseStripeKey: function () {
      return process.env.STRIPE_KEY
    },
    PurchaseStripeOptions: function () {
      return {
        email: (this.user) ? this.user.email : '',
        name: 'Microba',
        image: './static/stripe-thumbnail.png'
      }
    }

  }
}



// WEBPACK FOOTER //
// ./src/mixins/purchaseKits.js